import * as angular from "angular";

export class PrivacyNotice {
    public pnid: any = null;
    public pnheader: any = null;
    public pnbody: any = null;
    public pnversion: any = null;
    public pnstatus = "Active";
    public pncreator: any = null;

    constructor(data?: any) {
        if (data) {
            this.setData(data);
        }
    }

    setData(data: any): void {
        angular.extend(this, data);
    }
}
